import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Navigation from './navigation-exclamation';
import Footer from './footer';
import Hero from './assets/hero-3.svg';
import MobileHero from './assets/hero-mobile-2.svg';
import Business from './assets/undraw_business_deal.svg';
import Businessman from './assets/undraw_businessman.svg';
import Tourists from './assets/undraw_group_selfie.svg';
import Matt from './assets/matt-aidem.png';
import Aaron from './assets/aaron.png';
import Daniel from './assets/daniel.png';
import Dike from './assets/dike.png';
import Frances from './assets/frances.png';
import Raman from './assets/raman.png';
import Write from './assets/write.png';
import Rumblr from './assets/rumblr.png';
import Scribbleplus from './assets/scribble-plus.svg';
import {Helmet} from "react-helmet";


class ExclamationPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }



  render() {
    console.log(this.state.width);

    return (
      <div>
        <Helmet>
          <title>Exclamation by Scribble – Promote your blog posts on targeted subreddits with a single click</title>
          <meta name="description" content="Exclamation is a simple blog promotion tool for startups starting at $249/mo. Exclamation is the easiest way to grow your blog. ✈️" />

          <meta itemprop="name" content="Exclamation by Scribble – Promote your blog posts on targeted subreddits with a single click" />
          <meta itemprop="description" content="Exclamation is a simple blog promotion tool for startups starting at $249/mo. Exclamation is the easiest way to grow your blog. ✈️" />
          <meta itemprop="image" content="https://i.imgur.com/XhyGUZb.png" />

          <meta property="og:url" content="https://www.hiscribble.com/exclamation" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Exclamation by Scribble – Promote your blog posts on targeted subreddits with a single click" />
          <meta property="og:description" content="Exclamation is a simple blog promotion tool for startups starting at $249/mo. Exclamation is the easiest way to grow your blog. ✈️" />
          <meta property="og:image" content="https://i.imgur.com/XhyGUZb.png" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Exclamation by Scribble – Promote your blog posts on targeted subreddits with a single click" />
          <meta name="twitter:description" content="Exclamation is a simple blog promotion tool for startups starting at $249/mo. Exclamation is the easiest way to grow your blog. ✈️" />
          <meta name="twitter:image" content="https://i.imgur.com/XhyGUZb.png" />

        </Helmet>
        <Navigation />
        { this.state.width > 900 ? <img
          src={ Hero }
          className="is-overlay"
        /> : <img
          src={ MobileHero }
          className="is-overlay"
        />}

        <section className="section has-bg-image is-centered has-text-centered" style={{ height: "28em" }}>
          <div className="columns">
            <div className="column">
              <div className="container is-overlay has-padding-bottom has-text-centered">
                <div className="hero-div-width">

                  <h1 className="title has-text-white has-text-weight-bold is-hero-title is-size-2">
                    Use Exclamation to seamlessly promote your new blog posts on reddit in seconds ⚡️
                  </h1>
                   <br />
                </div>

                <AnchorLink href="#howitworks" className={ this.state.isActive ? 'button is-hiw-hero-exclamation' : 'button is-hiw-hero-exclamation'}>How it works</AnchorLink>
                <a className="button is-stripe-hero-exclamation" href="/pricing">Subscribe now</a>
                <p className="has-text-white is-size-6 is-hero-sub">
                  Perfect for automating your blog & newsletters
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="columns has-text-centered is-centered">
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2 has-padding-bottom">
                  ⏳
                </div>
                <div className="title is-size-4 para-title">
                  Save 20+ hours every month by automating your blog's growth
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  🚀
                </div>
                <div className="title is-size-4 para-title">
                  Seamlessly boost traffic to your blog and improve its SEO
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  🤑
                </div>
                <div className="title is-size-4 para-title">
                  Effortlessly find new customers and grow your audience
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section has-opaque-bg has-background-white">
          <div className="container has-text-centered is-centered clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered" id="pricing">Why Exclamation?</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Blogs are a great way to generate traffic for your product – unless nobody reads them. Without Exclamation, sharing your blog to the right communities is a time-expensive hassle.</p>
            </div>
            <div className="columns">
              <div className="column">
                <div className="has-text-centered">
                  <div className="circle-icon is-size-2">
                    🚀
                  </div>
                  <p className="has-text-weight-bold is-size-4">The easiest way to grow your blog––all on autopilot<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
              <div className="column">
                <div className="has-text-centered">
                  <div className="circle-icon is-size-2">
                    ⚡️
                  </div>
                  <p className="has-text-weight-bold is-size-4 person-title">Boost your SEO and bring in more targeted traffic<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column">
                <div className="has-text-centered">
                <div className="circle-icon is-size-2">
                  🍋
                </div>
                  <p className="has-text-weight-bold is-size-4 person-title">Juice every bit of traffic you can from your content – no more wasting growth opportunities<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
              <div className="column">
                <div className="has-text-centered">
                <div className="circle-icon is-size-2">
                  📣
                </div>
                  <p className="has-text-weight-bold is-size-4 person-title">Become a consistent voice in your target communities<br /><br /></p>
                  <p className="is-size-6">
                  </p>
                </div>
              </div>
            </div>
            <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
          </div>
        </section>

        <section className="section" id="howitworks">
          <div className="container clear-section-card-writing-samples">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">How it works</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Getting started with Scribble is simple and only takes a few minutes.</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  📝
                </div>
                <div className="title is-size-4 para-title">
                  1. Whenever you publish a new blog post, send us a link
                </div>

              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  ⚡️
                </div>
                <div className="title is-size-4 para-title">
                  2. We’ll generate a custom list of the 10 most relevant subreddits to submit to
                </div>

              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  🚀
                </div>
                <div className="title is-size-4 para-title">
                  3. We’ll submit your post to these subreddits within 5 days
                </div>
              </div>
            </div>
            <p className="subtitle has-text-centered is-centered pricing-below-text is-size-6">You can promote up to 5 blog posts through Exclamation every month. If you need help actually writing your blog, check out <a href="https://www.hiscribble.com/?ref=exclamation" className="is-link">Scribble</a>!</p>
          </div>
        </section>

        <section className="section">
          <div className="container clear-section-card">
            <div className="columns">
              <div className="column">
                <img
                  src={ Rumblr }
                  className="case-study-image"
                />
              </div>
              <div className="column is-para-case-study">
                <div className="title is-size-4 para-title">
                  Rumblr went viral on reddit, 4chan, and mainstream media in just 4 days
                </div>
                <p className="is-size-5">We used communities like reddit, 4chan, and Hacker News to launch Rumblr, garnering 100M+ impressions in less than a week</p>
                <a href="https://medium.com/the-mission/how-we-hacked-the-media-and-landed-six-figure-contracts-in-four-days-96ea4aca4eef" target="_blank">
                  <div className="button is-stripe-middle">READ THE CASE STUDY</div>
                </a>
              </div>
            </div>
          </div>

            <div className="container clear-section-card">
              <div className="columns">
                <div className="column is-hiw-card">
                  <div className="subtitle is-size-5 has-text-weight-normal">
                    "I've seen Matt and his team get millions of impressions and coverage for clients. I highly recommend their services."
                  </div>
                  <p class="is-size-6 has-text-weight-semibold">❤️ Founder of The Mission</p>
                </div>
                <div className="column is-hiw-card">
                  <div className="subtitle is-size-5 has-text-weight-normal">
                    "They did an excellent job increasing traffic to our website. We saw a major lift in both SEO and ASO after working with them."
                  </div>
                  <p class="is-size-6 has-text-weight-semibold">❤️ Founder of Yik Yak & The Q</p>
                </div>
                <div className="column is-hiw-card">
                  <div className="subtitle is-size-5 has-text-weight-normal">
                    "They saved us so much time. We concentrated on the product and let them do the hard work. We're very pleased with the results."
                  </div>
                  <p class="is-size-6 has-text-weight-semibold">❤️ Co-founder of Richie Invest</p>
                </div>
              </div>
            </div>
        </section>

        <section className="section">
          <div className="container clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">Writing and promoting your blog put on autopilot ✈️</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Scribble and Exclamation together is the easiest way to write and grow your blog.</p>
            </div>
              <a href="/?ref=exclamation">
                <img
                  src={ Scribbleplus }
                />
              </a>
          </div>
        </section>

        <section className="section" id="FAQ">
          <div className="container clear-section-card-writing-samples">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">FAQ</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">If our FAQ doesn't answer your questions, please reach out to us in our live chat in the bottom right.</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Do you only promote blog posts that you’ve written through Scribble?
                </div>
                <p className="is-size-6">Nope! You can give us any blog post you'd like––old or new.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Is Exclamation compatible with Scribble on demand blog writing?
                </div>
                <p className="is-size-6">Yes! We've designed Exclamation to be a perfect fit. With both of these products you can automate both the writing and growing of your blog.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  How many promotions can I run every month?
                </div>
                <p className="is-size-6">Up to 5!</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Do you offer refunds?
                </div>
                <p className="is-size-6">Until we've started processing one of your promotions.</p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default ExclamationPage;



// WEBPACK FOOTER //
// ./src/exclamation.js